import { render, staticRenderFns } from "./comentario.vue?vue&type=template&id=69234b6c&scoped=true"
import script from "./comentario.vue?vue&type=script&lang=js"
export * from "./comentario.vue?vue&type=script&lang=js"
import style0 from "./comentario.vue?vue&type=style&index=0&id=69234b6c&prod&scoped=true&lang=css"
import style1 from "./comentario.vue?vue&type=style&index=1&id=69234b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69234b6c",
  null
  
)

export default component.exports